<template>
  <!--
      [ 크기 옵션 : spacing--sm ]
      btn--xxxs
      btn--xxs
      btn--xs
      btn--sm
      btn--md
      btn--lg
      btn--xl
      btn--xxl
      btn--xxxl

      [ 아이콘 버튼 옵션 : ]
      .icon--btn

      [ 라운드 옵션 : ]
      .btn--radius-sm
      .btn--radius-md
      .btn--radius-lg
      .btn--round

      [ 히든 옵션 : spacing--sm ]
      .view--icon

      [ 아이콘 버튼 옵션 : ]
      .icon--btn

      [ 아이콘 사이즈 옵션 : icon--sm ]
      .icon--sm
      .icon--md
      .icon--lg

      [ 폰트 사이트 옵션 : font--sm]
      .font--sm
      .font--md
      .font--lg
    -->

  <button
    class="btn OPTION"
    :class="iconStyle"
    :type="type"
    v-on="listeners"
    :disabled="disabled"
  >
    <span
      class="btn__icon"
      v-if="icon"
    ><i class="material-icons">{{icon}}</i></span>
    <span class="btn__label">{{label}}</span>
    <span
      class="btn__counter"
      v-if="likes"
    >10</span>
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    type: { type: String, default: 'button' },
    disabled: { type: Boolean, default: false },
    icon: { type: String },
    likes: { type: Number }
  },
  computed: {
    iconStyle () {
      if (this.icon) {
        return 'icon--btn'
      }
      return ''
    },
    listeners () {
      return {
        ...this.$listeners,
        input: event =>
          this.$emit('input', event.target.value)
      }
    }
  }
}
</script>
